import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const GiftRedirect = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    if (id && navigate) {
      navigate(`/app/gifts/${id}/promo-claim`, { replace: true });
    }
  }, [id, navigate]);

  return null;
};

export default GiftRedirect;
